class AllowOnlyNumbersDirective {
    constructor() {
        this.restrict = 'A';
        this.require = 'ngModel';
    }

    link(scope, element, attrs, modelCtrl) {
        const maxLength = parseInt(attrs.length);

        modelCtrl.$parsers.push((inputValue) => {
            let transformedInput = inputValue ? inputValue.replace(/[^\d]/g, '') : '';

            if (transformedInput.length > 0 && maxLength && maxLength > 1) {
                transformedInput = transformedInput.length > maxLength ? transformedInput.substring(0, maxLength) : transformedInput;
            }

            if (transformedInput != inputValue) {
                modelCtrl.$setViewValue(transformedInput);
                modelCtrl.$render();
            }

            return transformedInput;
        });
    }

    static directiveFactory() {
        'ngInject';
        return new AllowOnlyNumbersDirective();
    }
}

export default AllowOnlyNumbersDirective;